
<labelable
  ref="labelableComponent"
  v-on="$listeners"
  v-bind="$attrs"
  :is-selected="objectModelAction.isSelected"
  v-model="objectModelAction.label_title"
  placeholder="Enter action name..."></labelable>
